module.exports = __webpack_public_path__ + "static/media/intent-invites-image.09b3b8d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/intent-invites-image.svg
// module id = 1197
// module chunks = 40